export const USER_URL = {
  UserSearch: `SearchUsers`,
  CheckIfUserIsAdmin: `CheckIfUserIsAdmin`,
  AddGroupMember: `AddGroupMember`,
  SignOut: `signout`,
};
